import emailjs from '@emailjs/browser';
import { useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import loader from '../../../assets/images/loader2.gif';
import CloseCircleIcon from '../../../components/Icons/CloseCircleIcon';
import useScrollRestoration from '../../../hooks/useScrollRestoration';
import s from './Question.module.scss';

const QuestionMobile = () => {
  const [loading, setLoading] = useState(false);
  const [errorResponse, setErrorResponse] = useState(false);
  const [name, setName] = useState('');
  const [showNameError, setShowNameError] = useState(false);
  const formRef = useRef();
  const [phone, setPhone] = useState('');
  const [question, setQuestion] = useState('');
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [phoneError, setPhoneError] = useState(false);

  const [isShowMinLength, setIsShowMinLength] = useState(false);
  const [isMinLengthError, setIsMinLengthError] = useState(true);
  useScrollRestoration(pathname);
  const handleChangeName = (e) => {
    setName(e.target.value);
  };
  console.log({ isPhoneValid });

  const handleChangePhone = (e) => {
    const input = e.target;
    setIsPhoneValid(input.validity.valid);
    setPhone(input.value);
  };
  const handleChangeQuestion = (e) => {
    const input = e.target;
    setIsMinLengthError(input.validity.tooShort);
    setQuestion(input.value);
  };
  const handleValidationPhone = (e) => {
    const input = e.target;

    const phonePattern = /^[0-9]{11}$/;

    if (!input.validity.valid) {
      if (input.validity.valueMissing) {
        input.setCustomValidity('Поле не должно быть пустым');
      } else {
        input.setCustomValidity('');
      }
    } else if (!phonePattern.test(input.value)) {
      input.setCustomValidity('Введите корректный номер телефона (11 цифр)');
    } else {
      input.setCustomValidity('');
    }
  };

  const handleValidationQuestion = (e) => {
    const input = e.target;
    if (input.validity.tooShort) {
      input.setCustomValidity('Вопрос должен быть не менее 50 символов');
    } else {
      input.setCustomValidity('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsShowMinLength(isMinLengthError);
    setShowNameError(!name);
    setPhoneError(!isPhoneValid);

    if (isMinLengthError || !name || !isPhoneValid) {
      return;
    }

    setLoading(true);
    const dfg = process.env.REACT_APP_EMAIL_SERVICE_ID;
    const dfg2 = process.env.REACT_APP_EMAIL_TEMPLATE_ID;
    const aaa = process.env.REACT_APP_EMAIL_PUBLIC_KEY;
    console.log(dfg, dfg2, aaa);
    const response = await emailjs.sendForm(
      process.env.REACT_APP_EMAIL_SERVICE_ID,
      process.env.REACT_APP_EMAIL_TEMPLATE_ID,
      formRef.current,
      { publicKey: process.env.REACT_APP_EMAIL_PUBLIC_KEY }
    );
    setLoading(false);
    if (response.status === 200) {
      navigate('/');
    } else {
      setErrorResponse(true);
    }
  };
  return (
    <div className={s.wrapper}>
      {!errorResponse ? (
        <>
          <h1>Задать вопрос</h1>
          <form ref={formRef} className={s.forms} onSubmit={handleSubmit}>
            <div className={s.name}>
              <input
                name="name"
                value={name}
                placeholder="Введите ваши Ф.И.О"
                onChange={handleChangeName}
                type="text"
              />
              {showNameError && <span className={s.errorName}>Введите ваши данные</span>}
              <div className={s.clear}>
                <CloseCircleIcon size="30px" color="#2222246a" onClick={() => setName('')} />
              </div>
            </div>
            <div className={s.phone}>
              <input
                name="phone"
                value={phone}
                onInput={handleValidationPhone}
                placeholder="Введите ваш телефон"
                onChange={handleChangePhone}
                type="tel"
              />
              {phoneError && <span className={s.errorPhone}>Введите телефон</span>}
              <div className={s.clear}>
                <CloseCircleIcon size="30px" color="#2222246a" onClick={() => setPhone('')} />
              </div>
            </div>
            <div className={s.question}>
              <textarea
                name="question"
                onInput={handleValidationQuestion}
                value={question}
                autoCapitalize
                autoComplete
                minLength={50}
                required
                placeholder="Введите ваш вопрос"
                onChange={handleChangeQuestion}
              />
              {isMinLengthError && isShowMinLength && (
                <span className={s.errorTextarea}>Минимальное числов символов 50 букв </span>
              )}
            </div>
            <div className={s.button}>
              <button disabled={loading}>
                <div className={s.contentButton}>
                  <snap>Отправить</snap>
                  {loading && (
                    <div className={s.load}>
                      <img src={loader} />
                    </div>
                  )}
                </div>
              </button>
            </div>
          </form>
        </>
      ) : (
        <div className={s.errorResponse}>
          <div className={s.message}>Что-то пошло не так. Попробуйте снова</div>
          <div className={s.reload} onClick={() => window.location.reload()}>
            Обновить
          </div>
        </div>
      )}
    </div>
  );
};

export default QuestionMobile;
